module.exports = __webpack_public_path__ + "779b8ed82f31ba864b478281ad518382.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-turkey.png
// module id = 2759
// module chunks = 0